var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.466,
    height: 53.466,
    viewBox: "0 0 53.466 53.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_963",
    "data-name": "Ellipse 963",
    cx: 26.733,
    cy: 26.733,
    r: 26.733,
    transform: "translate(0 0)",
    fill: "#fdf2d8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(11.042 12.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229261",
    "data-name": "Path 229261",
    d: "M26.164,28.607c-.085,0-.17,0-.256-.006H5.472A5.228,5.228,0,0,1,.7,25.97a5.142,5.142,0,0,1,.006-5.194L11.152,2.685a5.252,5.252,0,0,1,9.075,0L30.672,20.776a5.141,5.141,0,0,1,.006,5.194,5.244,5.244,0,0,1-4.514,2.637Z",
    transform: "translate(0 0)",
    fill: "#fcbe37",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229262",
    "data-name": "Path 229262",
    d: "M5.772,19.439H2.146a.858.858,0,0,1-.858-.858v-3a.858.858,0,0,1,.858-.858H5.772a.858.858,0,0,1,.858.858v3a.858.858,0,0,1-.858.858Zm0-5.874H2.146a.858.858,0,0,1-.857-.812L.676,1.324a.858.858,0,0,1,.857-.9H6.385a.858.858,0,0,1,.857.9L6.629,12.753a.859.859,0,0,1-.857.812Z",
    transform: "translate(11.731 5.945)",
    fill: "#fcab32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_341080944",
    transform: "translate(12.896 6.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_341078568",
    d: "M4.729,4.961A.368.368,0,0,0,5.1,4.593v-3a.367.367,0,0,0-.368-.368H1.1a.368.368,0,0,0-.368.368v3a.367.367,0,0,0,.368.368H4.729Z",
    transform: "translate(-0.122 13.078)",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_341074752",
    d: "M5.309,12.611a.368.368,0,0,0,.367-.348L6.289.834A.368.368,0,0,0,5.922.446H1.069A.368.368,0,0,0,.7.834l.613,11.429a.368.368,0,0,0,.367.348H5.309Z",
    transform: "translate(-0.701 -0.446)",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic-warning.3e418d5e20aadb31bb90ea9ef914f9d6.svg";
export { ForwardRef as ReactComponent };